import * as angular from 'angular';

import { ComponentDefinition, ConnectionPointType, ConnectionPoint } from '../../models/';
import { IGroupsImportService, ILoggerService } from '../../services/';

class DahsGroupsSearchController implements angular.IComponentController {
    displayedGroups: d3.layout.hierarchy.Result[][];
    hasModel: boolean = false;
    loadingMessage: string;
    isLoading: boolean;
    placeholders: {
        [index: number]: string;
    };
    searchString: string;
    selectedConnectionPoint: string;
    types = [ConnectionPointType.PIAF];
    
    static $inject = [
        'GroupsImportService',
        'loggerService'
    ];

    constructor(
        private _groupsImportService: IGroupsImportService,
        private _loggerService: ILoggerService
    ) {
        this.placeholders = {};
        this.placeholders[ConnectionPointType.PIAF] =
            'Search in AF (r:path to root element n:element name an:attribute name ac:attribute category u:attribute unit)';
    }

    search() {
        this.isLoading = true;
        this._groupsImportService
            .find(this.searchString, this.selectedConnectionPoint)
            .then(data => {
                this.displayedGroups = data;
            })
            .catch(reason => {
                if (reason.data && reason.data.message) {
                    this._loggerService.logError(reason.data.message);
                }
            })
            .finally(() => this.isLoading = false);
    }

    filter(model: ConnectionPoint): boolean {
        return this.types.indexOf(model.type) >= 0 && !!model.instance;
    }

    toggleIdentifers(g) {
        if (g._identifiers) {
            g._identifiers = null;
        } else {
            g._identifiers = g.identifiers.concat(g.parameters);
        }
    }
}

export const wtDahsGroupsSearch: ComponentDefinition = {
    componentId: 'wtDahsGroupsSearch',
    controller: DahsGroupsSearchController,
    template: require('./dahsGroupsSearch.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedConnectionPoint: '=?',
        isLoading: '<?'
    }
};
